import React, { useState, useEffect } from 'react';

function AiGeneratorsList({ generators, onDelete, onEditClick, hideActions = false }) {
  // Initialize the filter state by checking sessionStorage first.
  // If no filter is stored, default to 'all'.
  const [filter, setFilter] = useState(() => {
    return sessionStorage.getItem('generatorFilter') || 'all';
  });

  // Use a useEffect hook to save the filter state to sessionStorage
  // whenever it changes.
  useEffect(() => {
    sessionStorage.setItem('generatorFilter', filter);
  }, [filter]);

  const filteredGenerators = generators.filter((gen) => {
    if (filter === 'all') return true;
    return gen.type.toLowerCase().includes(filter);
  });

  return (
    <div className="mb-10">
      {/* Filter Dropdown */}
      <div className="mb-1">
        <label className="mr-2 font-medium text-white">Filter by Type:</label>
        <select
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
          className="border px-3 py-1 rounded"
        >
          <option value="all">All</option>
          <option value="image">Image Generators</option>
          <option value="video">Video Generators</option>
        </select>
      </div>

      {/* Table View */}
      <div className="overflow-x-auto">
        <table className="min-w-full bg-white border rounded shadow">
          <thead>
            <tr className="bg-gray-100 text-left">
              <th className="px-4 py-2 border">Type</th>
              <th className="px-4 py-2 border">URL</th>
              <th className="px-4 py-2 border">Description</th>
              {!hideActions && <th className="px-4 py-2 border">Actions</th>}
            </tr>
          </thead>
          <tbody>
            {filteredGenerators.length > 0 ? (
              filteredGenerators.map((gen) => (
                <tr key={gen._id} className="hover:bg-gray-50">
                  <td className="px-4 py-2 border font-semibold">{gen.type}</td>
                  <td className="px-4 py-2 border">
                    <a
                      href={gen.siteUrl}
                      className="text-blue-600"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {gen.siteUrl}
                    </a>
                  </td>
                  <td className="px-4 py-2 border">{gen.description}</td>
                  {!hideActions && (
                    <td className="px-4 py-2 border">
                      <div className="flex gap-2">
                        <button
                          onClick={() => onEditClick(gen._id)}
                          className="bg-yellow-500 px-3 py-1 text-white rounded"
                        >
                          Edit
                        </button>
                        <button
                          onClick={() => onDelete(gen._id)}
                          className="bg-red-600 px-3 py-1 text-white rounded"
                        >
                          Delete
                        </button>
                      </div>
                    </td>
                  )}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={hideActions ? 3 : 4} className="text-center text-gray-500 px-4 py-6">
                  No generators found for selected filter.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default AiGeneratorsList;
